export default "__VITE_ASSET__T0w4yWrH__"